import { socketWrapper } from '_helpers/socket-wrapper';

function useSocketAction() {
    function onConnected() {
        socketWrapper.isConnected = true;
    }

    return { onConnected };
}

export default useSocketAction;
